
import { post, fetch } from "@/ask/axios";
import Vue from 'vue';

// text:输入的文字, cb, dataOptions:所有数据, type 
export function fuzzyQuery(text, cb, dataOptions, type) {
    let data = dataOptions;
    // debugger
    // // console.log("🚀 ~ data", data)
    let searchRes = [];
    if (!text) {
        searchRes = data;
    } else {
        if (type !== 'AmazonWarehouse') {
            searchRes = data.filter(item => {
                let label = item.Cn + `[${item.En}]`
                if (type === 'destination country' || type === 'Departure airport' || type === 'Destination airport') {
                    label = item.Cn + `[${item.En}]` + `${item.Code}`
                }
                return label.toLowerCase().indexOf(text.toLowerCase()) > -1
            });
        } else {
            searchRes = data.filter(item => {
                let label = `${item.StoreCode} ${item.CityKey} ${item.PostCode}`
                return label.toLowerCase().indexOf(text.toLowerCase()) > -1
            });
        }
    }
    cb(searchRes);
}



export async function getCity(api) {
    //城市
    // let url = api + "/api/City/Query ";
    let url = Vue.prototype.$api04 + "/Basics/api/SysRegion/Query";
    const res = await post(url, { CountryID: "CN" });
    let cityOptions = res.Results;
    return cityOptions = cityOptions.map(v => {
        return { Cn: v.CityNameCh, En: v.CityNameEn, Key: v.CityKey };
    });
}

// 国家
export const getContry = async function (api) {
    const resCountry = await post(
        // api + "/api/EbayCustomer/Country/Query",
        // { api_key: "StartAirPort" }
        Vue.prototype.$api04 + "/Basics/api/Country/Query",
        {}
    );
    let countryOptions = resCountry.Results;
    return countryOptions = countryOptions.map(v => {
        return { Cn: v.CountryNameCh, En: v.CountryNameEn, Key: v.CountryKey, Code: v.CountryID };
    })
}

// 亚马逊
export const getStore = async function (api) {
    let res = await fetch(
        // api + "/api/EbayCustomer/FBAStoreAddress/QueryFBAStoreAddress"
        Vue.prototype.$api04 + "/FBA/api/FBAStoreAddress/QueryFBAStoreAddress"

    );
    // // console.log("🚀 ~ res", res)
    return res = res.Results;
    // return res = res.map(v => {
    //     return { Cn: v.CountryNameCh, En: v.CountryNameEn, Key: v.CountryKey };
    // })
}

// 机场
export const getAirport = async function (api) {
    const resCountry = await post(
        api + "/api/Airport/QueryPort",
        {}
    );
    let Options = resCountry.Results;
    return Options = Options.map(v => {
        return { Cn: v.AirportNameCh, En: v.AirportNameEn, Key: v.AirportCode3, Code: v.AirportCode3 };
    })
}
//起运机场
export const getStartAirport = async function (api) {
    const resCountry = await fetch(
        api + "/Air/api/Airline/StartAirportQuery",
        {}
    );
    // debugger
    let Options = resCountry.Results;
    return Options = Options.map(v => {
        return { Cn: v.AirportNameCh, En: v.AirportNameEn, Key: v.AirportCode3, Code: v.AirportCode3 };
    })
}
//时间总排序排序
function DateSort(resData) {
    return resData.sort((a, b) => {

        a = a.Time.match(/\d+/g).reduce((acc, cur) => acc + cur) - 0
        b = b.Time.match(/\d+/g).reduce((acc, cur) => acc + cur) - 0
        return a - b;
    });
}
// function timeSort(resData) {
//     // return resData.sort((a, b) => {
//     //     a = a.match(/\d+/g).reduce((acc, cur) => acc + cur) - 0
//     //     b = b.match(/\d+/g).reduce((acc, cur) => acc + cur) - 0
//     //     return a - b;
//     // });
//     let arr =[]
//     resData.forEach((v)=>{

//     })
// }

//抽取出的数据
let chartsProp = {
    Cost: { sortTitle: [], series: [] },
    TotalAmount: { sortTitle: [], series: [] },
    FreightRate: { sortTitle: [], series: [] },
    GoodsRate: { sortTitle: [], series: [] },
    Count: { sortTitle: [], series: [] },
    ProductQty: { sortTitle: [], series: [] },
    TraffAmount: { sortTitle: [], series: [] },
    TraffAmountBySingle: { sortTitle: [], series: [] },
    CusChargeWeight: { sortTitle: [], series: [] },
    GoodValues: { sortTitle: [], series: [] },
    DestAreaAmount: { sortTitle: [], series: [] },
    StartAreaAmount: { sortTitle: [], series: [] },
    InsuranceAmount: { sortTitle: [], series: [] },
    WorkDay: { sortTitle: [], series: [] },
};
//echarts数据
export const getEcharts = async function (api, params, wayType, that) {
    // debugger
    // // console.log("🚀 ~ that", that)
    let charts = JSON.parse(JSON.stringify(chartsProp))
    let url =
        api + "/api/TradeCustomer/WayBillInfoReport/QueryWayBillInfo";
    let resData = await post(url, params);



    // // console.log("🚀 ~ resData", resData)
    //为空返回
    if (resData.length === 0 || Object.prototype.toString.call(resData) === '[object Object]') {
        return false
    }
    // debugger
    //排序
    resData = resData.reverse();
    // // console.log("🚀 ~ resData", resData)

    const dataSeries = [];

    let types = resData.map(v => {
        // if (v.WaybillChildType == 2) {
        //     v.WaybillType = 22
        // }
        return v.WaybillType
    });

    types = [...new Set(types)];
    // // console.log("🚀 ~ types", types)
    //填充总览
    if (!wayType) {

        let timeMap = {}
        // // resData.map((v) => {
        // //     return { Time: v.Time, WaybillType: v.WaybillType }
        // // })
        let times = resData.map((v) => {
            // timeMap[v.time] = []
            return v.Time
        })
        times = [...new Set(times)];
        times.forEach((v) => {
            timeMap[v] = []
        })
        resData.forEach((v) => {
            // for (let i in times) {
            times.forEach((t) => {
                if (v.Time === t) {
                    timeMap[t].push(v.WaybillType)
                }
            })

            // }
        })
        for (let i in timeMap) {
            types.forEach((v) => {
                if (!timeMap[i].includes(v)) {
                    let nullData = JSON.parse(JSON.stringify(resData[0]))
                    for (let k in nullData) {
                        nullData[k] = 0
                    }
                    nullData.Time = i
                    nullData.WaybillType = v
                    // resData.push(nullData)
                    let index = resData.findIndex((v) => {
                        return v.Time === i
                    })
                    resData.splice(index, 0, nullData)
                }
            })
        }

    }
    //填充child
    // fillChild()
    if (resData[0].Child) {
        let allChild = resData.flatMap((v) => {
            v.Child.forEach(c => {
                c.Time = v.Time
            })
            return v.Child
        })
        // allChild = DateSort(allChild)
        // // console.log("🚀 ~ allChild", allChild)
        let types = allChild.map(v => v.BaseModeCode);
        types = [...new Set(types)];

        //填充空数据数据
        resData.forEach((v, index) => {
            types.forEach((t) => {
                // 诺存在,就return
                let exist = v.Child.some(c => {
                    return c.BaseModeCode === t
                })
                if (exist) {

                } else {
                    let nullData = JSON.parse(JSON.stringify(v.Child[0]))
                    for (let k in nullData) {
                        nullData[k] = 0
                    }
                    nullData.BaseModeCode = t
                    resData[index].Child.push(nullData)

                }
            })
        })
    }

    // resData.forEach(item => {
    //     item.Child.length
    // })
    // debugger
    let datasChild
    if (wayType && that.sortSel.indicators === 'Total') {
        //单个

        if (filterData(wayType, resData, that).datasChild) {
            datasChild = filterData(wayType, resData, that).datasChild
        }
        dataSeries.push(filterData(wayType, resData, that));

    } else {
        //总览
        // debugger
        if (that.sortSel.indicators === 'Average' && wayType) {
            types = resData.map(v => v.BaseModeCode);
        }
        // // 当总览时加上专项
        // debugger
        // types.push(22)
        types.forEach(type => {
            dataSeries.push(filterData(type, resData, that));
        });
    }




    let timeMax = resData.map((v) => {
        return v.Time
    })
    // 去重排序
    timeMax = [...new Set(timeMax)]
    //转换为英语
    toEnglish(timeMax, that)
    // const timeMax = dataSeries[0].times
    dataSeries.forEach((v) => {
        for (let k in v.datas) {
            if (k === 'name' || k === 'FreightRate' || k === 'GoodsRate') continue
            charts[k].series.push({ data: v.datas[k], name: v.datas.name })
            charts[k].sortTitle = timeMax
        }
    })
    // FreightRate: (3)[0.9994528792230885, 0.9747737206180954, 0.9747737206180954]
    // GoodsRate:
    const rate = [{
        data: [],
        name: ''
    }, {
        data: [],
        name: ''
    }]

    rate[0].data = dataSeries[0].datas.FreightRate
    rate[0].name = 'freight'
    rate[1].data = dataSeries[0].datas.GoodsRate
    rate[1].name = 'value'
    // // console.log("🚀 ~ rate", rate)
    // debugger
    //保留小数
    const indMap = {
        7: 3,
        10: 3,
        2: 1,
        3: 1,
    }
    // 保留小数位

    for (let k in charts) {
        charts[k].series.forEach(v => {
            v.data.forEach((d, index) => {
                if (d) {
                    v.data[index] = d.toFixed(indMap[that.sortSel.indicators1] ? indMap[that.sortSel.indicators1] : 2) - 0
                    // // // console.log("🚀 ~ d", v.data[index])
                }
            })
        })
    }
    for (let k in datasChild) {
        datasChild[k].forEach(item => {
            item.data.forEach((v, index) => {
                if (v == null) {
                    v = 0
                }
                item.data[index] = v.toFixed(indMap[that.sortSel.indicators1] ? indMap[that.sortSel.indicators1] : 2) - 0
            })
        })
    }


    // // console.log("🚀 ~ charts", charts)
    // // console.log("🚀 ~ datasChild", datasChild)
    // debugger
    // Object.values(charts).forEach(item => {
    //     item.series.forEach(v => {
    //         v.data.forEach(d => {
    //             d = d.toFixed(2) - 0
    //         })
    //     })
    // })

    charts.rate = { series: rate, sortTitle: timeMax }
    // debugger
    return { charts, datasChild, }
}
function filterChild(t, resData, type, allType) {
    const data = {}
    allType.forEach(v => {
        data[v] = []
    })

    resData.forEach(item => {
        // // // console.log("🚀 ~ item", item)
        if (item.BaseModeCode === t) {
            // console.log("🚀 ~ item['Cost']", item['Cost'])
            data[t].push(item[type])
            // data[t].push(item['TotalAmount'])
            // datas.TotalAmount.push(item['TotalAmount']);
            // datas.FreightRate.push(item['FreightRate']);
            // datas.GoodsRate.push(item['GoodsRate']);
            // times.push(item.Time);
        }
    })
    return { name: t, data: data[t] }
}
const filterData = function (t, resData, that) {
    // 1：快递 ，2 ：小包 ，3 ：空运，4：海运整柜，5：海运散货，20：FBA头程，7：取件 ,
    // debugger

    // const TypeMap = {}

    // that.childMenu.forEach(item => {
    //     TypeMap[item.value] = item.label
    // })
    // delete TypeMap['1,3,7,20']
    // // // console.log("🚀 ~ TypeMap", TypeMap)
    const TypeMap = {
        1: "Express",
        3: "Air",
        20: 'FBA',
        7: '取件',
        22: 'specialLine',
        2: '小包',
        4: '海运整柜', 5: '海运散货',
    };
    let navC = that.activeChild

    // if (t === 22) {
    //     navC = t = 1
    //     TypeMap['1'] = 'specialLine'
    //     //specialLine是快递的子集
    // }
    const chartsProps = JSON.parse(JSON.stringify(chartsProp))
    let datas = {}
    Object.keys(chartsProps).forEach((key) => {
        datas[key] = []
    })
    // const datas = {
    //     Cost: [],
    //     TotalAmount: [],
    //     FreightRate: [],
    //     GoodsRate: [],
    //     Count: [],
    //     ProductQty: [],
    //     TraffAmount: [],
    //     TraffAmountBySingle: [],
    //     CusChargeWeight: [],
    //     GoodValues: [],
    //     DestAreaAmount: [],
    //     StartAreaAmount: [],
    //     InsuranceAmount: [],
    //     WorkDay: [],
    // };

    const times = [];
    let datasChild = JSON.parse(JSON.stringify(datas))
    // 如果不存在,则为Average数据

    resData.forEach(item => {
        // debugger
        if (TypeMap[t] ? navC.toString().length < 3 ? navC == t : item.WaybillType === t : item.BaseModeCode === t) {
            // // console.log("🚀 ~ item", item)
            Object.keys(chartsProps).forEach((key) => {
                datas[key].push(item[key])
            }
            )
            // datas.Cost.push(item['Cost']);
            // datas.TotalAmount.push(item['TotalAmount']);
            // datas.FreightRate.push(item['FreightRate']);
            // datas.GoodsRate.push(item['GoodsRate']);
            // datas.Count.push(item['Count']);
            // datas.ProductQty.push(item['ProductQty']);
            // datas.TraffAmount.push(item['TraffAmount']);
            // datas.TraffAmountBySingle.push(item['TraffAmountBySingle']);
            // datas.CusChargeWeight.push(item['CusChargeWeight']);
            // datas.GoodValues.push(item['GoodValues']);
            // datas.DestAreaAmount.push(item['DestAreaAmount']);
            // datas.StartAreaAmount.push(item['StartAreaAmount']);
            // datas.InsuranceAmount.push(item['InsuranceAmount']);
            // datas.WorkDay.push(item['WorkDay']);

        }
    });
    // 有孩子把孩子取出
    if (resData[0].Child) {
        let allChild = resData.flatMap((v) => {
            v.Child.forEach(c => {
                c.Time = v.Time
            })
            return v.Child
        })
        // allChild = DateSort(allChild)
        // // console.log("🚀 ~ allChild", allChild)
        let types = allChild.map(v => v.BaseModeCode);
        types = [...new Set(types)];

        //填充空数据数据
        // resData.forEach((v, index) => {
        //     types.forEach((t) => {

        //         if (v.Child.BaseModeCode === t) {

        //         } else {
        //             let nullData = JSON.parse(JSON.stringify(v.Child[0]))
        //             for (let k in nullData) {
        //                 nullData[k] = 0
        //             }
        //             nullData.BaseModeCode = t
        //             resData[index].Child.push[nullData]

        //         }
        //     })
        // })
        // debugger

        types.forEach(type => {
            Object.keys(datasChild).forEach((key) => {
                datasChild[key].push(filterChild(type, allChild, key, types));
            })
        });
        // // console.log("🚀 ~ datasChild", datasChild)
    }
    // debugger

    //当为Average时,直接t
    datas.name = TypeMap[t] ? TypeMap[t] : t

    // debugger
    // // console.log("🚀 ~ datas", datas)
    // // console.log("🚀 ~ t", t)
    console.log("🚀 ~ TypeMap[t]", TypeMap[t])

    // debugger
    return { datas, times, datasChild };
};
//转换参数
export const conversionParameters = function (that) {
    const toDate = function (t) {
        if (!t) return
        var array = t.split("-");
        return new Date(array[0], array[1], array[2]);
    };

    const params = {};
    // params.WaybillStatus = that.sortSel.WaybillStatus;
    // params.WaybillStatus = 1;
    //DeliveryTime
    if (that.sortSel.deliveryTm.dateVal) {
        params.OutStoreStartTime = toDate(that.sortSel.deliveryTm.dateVal[0]);
        params.OutStoreEndTime = toDate(that.sortSel.deliveryTm.dateVal[1]);
    }
    //CompletionTime
    if (that.sortSel.completeTm.dateVal) {
        params.CompleteStartTime = toDate(that.sortSel.completeTm.dateVal[0]);
        params.CompleteEndTime = toDate(that.sortSel.completeTm.dateVal[1]);
    }
    // 国家
    if (that.sortSel.country.item) {
        params.DestCountryKey =
            that.sortSel.country.item.Key
    }
    //城市
    if (that.sortSel.city.item) {
        params.DestCityKey =
            that.sortSel.city.item.Key
    }
    //起运机场
    if (that.sortSel.startAirport.item) {
        params.StartPort =
            that.sortSel.StartPort.item.Key
    }
    //Destination airport
    if (that.sortSel.endAirport.item) {
        params.StartPort =
            that.sortSel.endAirport.item.Key
    }
    //第一个Statistical indicators
    console.log(5888);
    params.Average = that.sortSel.indicators === 'Average' ? true : false
    //第二个Statistical indicators
    // params.Comprehensive = 1
    if (that.name !== 'product') {
        params.Comprehensive = that.sortSel.indicators1
    } else {
        params.Comprehensive = 10
    }
    //亚马逊
    if (that.sortSel.amazon.item) {
        params.FBAStoreCode = that.sortSel.amazon.item.FBAStoreAddressID
    }
    //运输类型
    const wayType = {
        "1,3,7,20": '',
        "1": 1,
        '3': 3,
        '20': 20,
        '7': 7,
        '22': 22
    }

    if (wayType[that.activeChild]) {
        if (wayType[that.activeChild] === 22) {
            params.WaybillChildType = 2
            wayType[that.activeChild] = 1
        }
        params.WaybillType = wayType[that.activeChild]
    }
    //收获发货
    if (that.sortSel.consignor.label) {
        params.Consignor =
            that.sortSel.consignor.label
    }
    if (that.sortSel.consignee.label) {
        params.Consignee = that.sortSel.consignee.label
    }

    //订单状态
    //进行中
    const orderMap = {
        ing: {
            "1,3,7,20": [2, 3, 8],
            "1": [3, 8],
            '3': [2, 3],
            '20': [3, 8]
        },
        done: {
            "1,3,7,20": [4, 10],
            "1": [10],
            '3': [4],
            '20': [10]
        },
        all: {
            "1,3,7,20": [4, 10, 2, 3, 8],
            "1": [10, 3, 8],
            '3': [4, 2, 3],
            '20': [10, 3, 8]
        }
    }
    //运输数量
    const countMap = {
        'Number of products in transit': {
            "1,3,7,20": [1, 4, 2, 3, 8],
            "1": [2, 3, 8],
            '3': [1, 2, 3],
            "7": [2, 3, 8],
            '20': [2, 3, 8]
        },
        'Number of products delivered': {
            "1,3,7,20": [4, 5, 10,],
            "1": [10],
            '3': [4],
            "7": [5],
            '20': [10]
        }
    }
    // debugger
    // params.WaybillType = wayType[that.activeChild]
    if (that.name === 'product') {
        if (wayType[that.activeChild] !== undefined) {
            if (that.sortSel.indicators1 === "Number of products in transit") {
                params.WaybillStatus = countMap['Number of products in transit'][that.activeChild]
            } else {
                params.WaybillStatus = countMap['Number of products delivered'][that.activeChild]
            }

        }
    } else {
        // if (wayType[that.activeChild]) {
        if (that.sortSel.WaybillStatus.length === 2) {
            params.WaybillStatus = orderMap.all[that.activeChild]
        }
        else if (that.sortSel.WaybillStatus.includes(1)) {
            params.WaybillStatus = orderMap.done[that.activeChild]
        }
        else if (that.sortSel.WaybillStatus.includes(0)) {
            params.WaybillStatus = orderMap.ing[that.activeChild]
        }
        else {
            params.WaybillStatus = []
        }
        // }
    }

    // const orderMap = {
    //     0: [3, 8]
    // }
    // params.WaybillStatus = that.sortSel.WaybillStatus
    // 1：周 2：月 3：季度 4:年
    params.GroupBy = that.sortSel.dateState;
    // // console.log("🚀 ~ params", params)
    return params
    // params.DestCityKey = that.sortSel.city.item
    //     ? that.sortSel.city.item.Key
    //     : "";
    // params.DestCountryNameEn = that.sortSel.country.item
    //     ? that.sortSel.country.item.En
    //     : "";
    // params.DestCountryName = that.sortSel.country.item
    //     ? that.sortSel.country.item.Cn
    //     : "";


    // params.DestCityName = that.sortSel.city.item
    //     ? that.sortSel.city.item.Cn
    //     : "";
    // params.DestCityNameEn = that.sortSel.city.item
    //     ? that.sortSel.city.item.En
    //     : "";



    //城市
    //     params.StartPortName = that.sortSel.startAirport.item
    //         ? that.sortSel.startAirport.item.Cn
    //         : "";
    // params.StartPortNameEn = that.sortSel.startAirport.item
    //     ? that.sortSel.startAirport.item.En
    //     : "";
    // params.DestPort = that.sortSel.startAirport.item
    //     ? that.sortSel.startAirport.item.Key
    //     : "";
    // 机场
    // params.StartPortName = that.sortSel.endAirport.item
    //     ? that.sortSel.endAirport.item.Cn
    //     : "";
    // params.StartPortNameEn = that.sortSel.endAirport.item
    //     ? that.sortSel.endAirport.item.En
    //     : "";
    // params.country = that.sortSel.endAirport.item
    //     ? that.sortSel.endAirport.item.Key
    //     : "";
    //国家
    // params.DestPort = that.sortSel.endAirport.item
    //     ? that.sortSel.endAirport.item.Key
    //     : "";

    //     params.OutStoreStartTime = that.sortSel.deliveryTm[0]
    // params.OutStoreEndTime = that.sortSel.deliveryTm[1]


}

//过滤tab
export const filterTab = function (defTab) {
    // let arr = JSON.parse(sessionStorage.getItem("MenuInfos"));
    // // // console.log("🚀 ~ arr", arr);
    let menuTab = [
        {
            label: "Overview",
            value: "1,3,7,20"
        },
        {
            label: "Express",
            value: "1"
        },
        {
            label: "Air",
            value: "3"
        },


    ];

    // arr = arr[1].ChilMenus.map(v => {
    //     if (v.IsShow) {
    //         return v.ChildMenuName;
    //     }
    // });

    // const map = defTab
    // // debugger;
    // arr.forEach(menu => {
    //     Object.keys(map).forEach(v => {
    //         if (menu && menu.includes(v)) {
    //             menuTab.push({
    //                 label: v,
    //                 value: map[v]
    //             });
    //         }
    //     });
    // });
    // // // console.log("🚀 ~ menuTab", menuTab)
    return menuTab;
}

//时间格式转英文
function toEnglish(times, that) {

    if (that.sortSel.indicators1 === 2 || that.sortSel.indicators1 === 3) {
        times.forEach((t, index) => {
            console.log("🚀 ~ t", t)
            t = t.replace('至', ' to ')


            times[index] = t

        })
        return
    }
    if (that.sortSel.dateState === 1) {
        times.forEach((t, index) => {
            console.log("🚀 ~ t", t)
            t = t.replace('第', 'week ')
            t = t.replace('周', '')
            console.log("🚀 ~ t", t)
            times[index] = t
        })
    }
    else if (that.sortSel.dateState === 2) {
        times.forEach((t, index) => {
            console.log("🚀 ~ t", t)
            t = t.replace('年', '-')
            t = t.replace('月', '')
            console.log("🚀 ~ t", t)
            times[index] = t
        })
    }
    else if (that.sortSel.dateState === 4) {
        times.forEach((t, index) => {
            console.log("🚀 ~ t", t)
            t = t.replace('年', '')

            console.log("🚀 ~ t", t)
            times[index] = t
        })
    }
}




// WEBPACK FOOTER //
// ./src/components/userCenter/statement/utils.js